// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

const baseURL = window.config?.CHOREO_SERVICES_ENDPOINT ?? "";

// export const getEmployees = "https://mobileinternal.wso2.com/api/external/employees?employeeStatus=Active,Marked leaver"

export const getEmployeeEmails = baseURL + "employees/emails";

export const getEmployeeVisaById = baseURL + "employees/$email/visas/$id";
export const getEmployeeVisaImage = baseURL + "employees/$email/visa-image/$id";

export const getEmployeeOwnVisaImage = baseURL + "employees/own-visa-image/$id";

export const getEmployeeTravelDocumentById =
  baseURL + "employees/$email/travel-documents/$id";
export const getEmployeeTravelDocumentImage =
  baseURL + "employees/$email/travel-document-image/$id";

export const getEmployeeOwnTravelDocumentImage =
  baseURL + "employees/own-travel-document-image/$id";

export const getTravelRequest = baseURL + "travels/$jobNumber";
export const postValidateAgentTravel =
  baseURL + "validate-agent-travel/$jobNumber";

export const getTravelAgents = baseURL + "travel-agents";
export const getPerdiemMetaData = baseURL + "per-diem-meta-data";
export const getPerdiemAllocations =
  baseURL + "travels/$jobNumber/per-diems";
export const getPerdiemPayments = baseURL + "travels/$jobNumber/per-diems/payments";
export const getPaymentCurrencyFilters = baseURL + "per-diems/payments/currency-filter";
export const getTotalPerDiemPaymentsCount = baseURL + "per-diems/payments/$jobNumber/count";

export const getTravelInvoices = baseURL + "travels/$jobNumber/invoices";
export const getInvoiceCostTypes = baseURL + "invoice-cost-types";

export const getRoles = baseURL + "roles";
export const getPrivileges = baseURL + "privileges";
export const getPrivilegesByUser = baseURL + "privileges-by-user";
export const getPrivilegesByRole = baseURL + "privileges-by-role";

export const getFundingSources =
  baseURL + "allocations/$allocationId/funding-sources";

export const getTravelCards = baseURL + "travels/$jobNumber/travel-cards"

export const postSearchVisas = baseURL + "visa-search";
export const postSearchOwnVisas = baseURL + "own-visa-search";
export const postSearchTravelDocuments = baseURL + "travel-document-search";
export const postSearchOwnTravelDocuments =
  baseURL + "own-travel-document-search";
export const postSearchTravelRequests = baseURL + "travel-search";
export const postSearchPerdiemPayments = baseURL + "per-diems/payments/search";
export const postSearchTravelInvoices = baseURL + "travel-invoice-search";
export const postAgentTravelRequests = baseURL + "agent-travel-search";

export const postRoles = baseURL + "roles";

export const postEmployeeOwnVisa = baseURL + "employees/own-visas";
export const postEmployeeOwnTravelDocument =
  baseURL + "employees/own-travel-documents";
export const postEmployeeTravelDocument =
  baseURL + "employees/travel-documents";
export const postEmployeeVisa = baseURL + "employees/visas";

export const getPerdiemPaymentSummary = baseURL + "travels/$jobNumber/per-diems/payments/summary";
export const getTotalPerdiemsCount = baseURL + "per-diems/$jobNumber/count";
export const postPerdiemAllocations =
  baseURL + "travels/$jobNumber/per-diems";
export const postPushPerdiemPaymentsByJobNumber = 
  baseURL + "travels/$jobNumber/per-diems/payments/push";
export const postPushPerdiemsPayments = 
  baseURL  + "per-diems/payments/push";
export const postPerdiemPayments =
  baseURL + "travels/$jobNumber/per-diems/payments";

export const postTravelCards = baseURL + "travels/$jobNumber/travel-cards"

export const postTravelInvoices = baseURL + "travels/$jobNumber/invoices";
export const postPushInvoicesByJobNumber =
  baseURL + "travels/$jobNumber/invoices/push";
export const postPushInvoices = baseURL + "push-invoices";

export const patchRolePrivileges = baseURL + "role-privileges";

export const patchEmployeeTravelDocument = baseURL + "update-travel-document";
export const patchEmployeeVisa = baseURL + "update-visa";

export const postTravelDocumentImage =
  baseURL + "travel-documents/$documentId/image/$imageName";
export const postVisaImage = baseURL + "visas/$visaId/image/$imageName";

export const patchAssignTravelRequest = baseURL + "assign-travel";
export const patchTravelStatus = baseURL + "update-travel-status";
export const patchTravelAgent = baseURL + "update-travel-agent";
export const patchTravelVisa = baseURL + "update-travel-visa";

export const patchApproveInvoices = baseURL + "approve-invoices";
export const patchRejectInvoices = baseURL + "reject-invoices";
export const patchPerDiemPayments = baseURL + "travels/$jobNumber/per-diems/payments";

export const deletePerdiemAllocation = baseURL + "per-diems/$id";
